export default __webpack_public_path__ + "static/media/Logo_SNDIF.fb7ab21e.png";